
export class HeaderDTO{

    aplicacion: String;
    funcionalidad: String;
    usuarioId : number;
    gmt: number;

    constructor(){};
}